import { sendFetch, POST_OPTIONS, GET_OPTIONS } from './base.service';

const BASE_PATH = '/ean';

export const findEanByClient = async (client) => {
    return await sendFetch(`${BASE_PATH}/all/client/${client}`, GET_OPTIONS);
}

export const findEanByClientColorProduct = async (client, color, product) => {
    return await sendFetch(`${BASE_PATH}/combination/${client}/${color}/${product}`, GET_OPTIONS);
}

export const createEan = async (body) => {
    return await sendFetch(`${BASE_PATH}/create`, POST_OPTIONS, body);
}

export const editEan = async (body, id) => {
    return await sendFetch(`${BASE_PATH}/edit/${id}`, POST_OPTIONS, body);
}